// extracted by mini-css-extract-plugin
var _1 = "ReferralModal-module__description--tmOwI";
var _2 = "ReferralModal-module__field--o6wm6";
export { _1 as "description", _2 as "field" }
